import React, { useState } from 'react';
import { BorrowerHeader } from './components/BorrowerHeader';
import { StepIndicator } from './components/StepIndicator';
import { ReportPicker } from './components/ReportPicker';
import { LiabilityStep } from './components/LiabilityStep';
import { creditReports } from './data/reports';
import { CreditReport, Liability } from './types/credit';
export function App() {
  const [reports, setReports] = useState<CreditReport[]>(creditReports);
  const [selectedReportId, setSelectedReportId] = useState<string | null>(null);
  const selectedReport = reports.find(r => r.id === selectedReportId) ?? null;
  const handlePush = async (ids: string[]) => {
    await new Promise(resolve => setTimeout(resolve, 1200));
    setReports(prev => prev.map(report => report.id !== selectedReportId ? report : {
      ...report,
      liabilities: report.liabilities.map((liability: Liability) => ids.includes(liability.id) ? {
        ...liability,
        alreadyPushed: true
      } : liability)
    }));
  };
  return <div className="flex min-h-screen w-full flex-col bg-canvas" data-id="element-0" data-mp="3mjq2lgp4euvl">
      <BorrowerHeader data-id="element-1" data-mp="3rdaquh0wwahl" />
      <StepIndicator current={selectedReport ? 2 : 1} onBack={() => setSelectedReportId(null)} data-id="element-2" data-mp="3rcswxr1q28cu" />

      <main className="flex-1" data-id="element-3" data-mp="82j0zgp5o9c">
        {selectedReport ? <LiabilityStep key={selectedReport.id} report={selectedReport} liabilities={selectedReport.liabilities} onBack={() => setSelectedReportId(null)} onPush={handlePush} data-id="element-4" data-mp="2zmepackaxs9m" /> : <ReportPicker reports={reports} onSelect={report => setSelectedReportId(report.id)} data-id="element-5" data-mp="3dkl4ucldv5kh" />}
      </main>
    </div>;
}